import React from "react";
import styles from "../Borku/borku.module.css";
import BannerV1 from "../../../components/Banners/Banner-v1/banner-v1";
import TextOnly from "../../../components/TextOnly/textOnly";
import ImageWithText from "../../../components/ImageWithText/ImageWithText";
import TextWithBg from "../../../components/TextWithBg/TextWithBg";
import Animations from "../../../components/Animations/animations";
import MetaTags from "../../../components/MetaTags";

const Borku = () => {

  const image = { url: "assets/borku-banner.webp", alt: "Borku app" };

  const headingOneContent = {
    mainTitle: "Borku",
    subTitle: "Dedicated",
    highlightedText: ["African", "Cuisine"],
    description: "Delivery Solution",
  };

  const subText =
    "A dedicated platform celebrating African food lovers and makers!";

  const powerByContent = [
    {
      heading: "Borku - African Food & Grocery Platform",
    },
    {
      subText: `Borku is a food delivery solution designed exclusively to celebrate and promote African cuisine. Powered by Enatega, Borku was developed by Ninjas Code to bring a unique and authentic food delivery experience to its users. Catering to both traditional and modern African dishes, Borku bridges a gap in the food delivery market, providing customers with an accessible way to enjoy diverse African flavors. Through a fully customized interface and enhanced ordering capabilities, Borku creates a seamless experience for both diners and restaurants.
        
      Borku exemplifies how the Enatega platform can be tailored to meet specific cultural and regional demands. With a clear focus and vision from Borku, combined with the technical and development expertise of Ninjas Code, this collaboration has resulted in a one-of-a-kind food delivery solution for the African culinary scene.`,
    },
  ];

  const aboutContent = [
    {
      aboutImage: { url: "assets/borku-1.webp", alt: "Borku App" },
      aboutTitle: {
        title: "Onboarding",
        highlightedTitle: "Restaurants with Ease",
      },
      aboutDescription: `Borku’s onboarding was streamlined for African restaurants, many of which are first-time users of a delivery app platform. With a user-friendly signup process, restaurant owners can easily list their menus, add popular dish variations, and manage orders efficiently. Custom-built forms within Borku allow restaurant partners to sign up and get access to their vendor panel. They can specify dish ingredients and customize how their dishes appear in-app, ensuring authenticity in presentation. The specialized dashboard for vendors also allows managing inventory, tracking orders, and viewing the analytics of their business.`,
      flexReverse: "false",
    },
    {
      aboutImage: { url: "assets/borku-2.webp", alt: "Borku App" },
      aboutTitle: {
        title: "Onboarding",
        highlightedTitle: "Restaurants with Ease",
      },
      aboutDescription: `To meet the expectations of African food enthusiasts, Borku’s UI received a full redesign, giving it a distinct, vibrant look that captures the spirit of African cuisine. Ninjas Code worked to craft a visually appealing, culturally resonant user interface that simplifies browsing, ordering, and delivery tracking. The design emphasizes Borku’s rich menu options, allowing customers to explore dishes and their origins. Both the web and mobile apps were created with colorful visuals and intuitive layouts.`,
      flexReverse: "true",
    },
    {
      aboutImage: { url: "assets/borku-3.webp", alt: "Borku App" },
      aboutTitle: {
        title: "Streamlined Payment and",
        highlightedTitle: "Ordering Processes",
      },
      aboutDescription: `Borku provides multiple payment options, including card, mobile wallet, and cash on delivery, to accommodate regional preferences. The ordering process includes order customization options, ensuring customers can personalize their meals while receiving real-time updates on their orders. These simple changes help enhance the overall user experience, meeting the unique expectations of its target audience.`,
      flexReverse: "false",
    },
  ];
  

  const conclusionText = {
    heading: "The Future for Borku",
    description:
      "Borku is a platform built to honor African culinary heritage and offer a dedicated space for African cuisine within the food delivery industry. Through collaborative efforts between Borku and Ninjas Code, this solution is set to redefine how African food is enjoyed and accessed, making it easier for people to savor beloved flavors or discover new ones. Borku’s ongoing story showcases how technology, when repurposed to a specific market, can elevate the cultural relevance and accessibility of a dining experience.",
    highlightedText:
      "With a foundation rooted in innovation and respect for African culinary diversity, Borku is setting a new standard in niche focused food delivery solutions.",
  };
  return (


    <div>
     <MetaTags
     title="Borku: An African Cuisine Delivery Platform"
     description="Borku is a food delivery app dedicated to African cuisine. Vibrant UI, easy restaurant onboarding, and multiple payment options. Explore it now!"
     />
      <BannerV1
        image={image}
        noPadding
        headingOne={headingOneContent}
        subText={subText}
      />

      <TextOnly content={powerByContent} />

      <section className={styles.aboutSec}>
        <div className={styles.container}>
        <Animations animationType="fadeInUp" threshold={0.2}>
          <h2>Building Borku: From Concept to Launch</h2>
          </Animations>
          <ImageWithText
            aboutContent={aboutContent}
          />
        </div>
      </section>
      <TextWithBg content={conclusionText} />
    </div>

  );
};

export default Borku;
